import { render, staticRenderFns } from "./entrepreneurship.vue?vue&type=template&id=998f3d2c"
import script from "./entrepreneurship.vue?vue&type=script&lang=js"
export * from "./entrepreneurship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports